import { getStandardFieldType } from 'reporting-ui-components/lib/report-strategies/shared/utils/reportGetters';
import { STANDARD_FIELD_TYPES } from 'reporting-ui-components/lib/report-strategies/shared/constants/fieldTypes';
import { isConfigReport, isJourneyReport } from 'reporting-data/tsTypes/reportTypes';
import { isSearchReport } from 'reporting-data/report/configReportGetters';
import { getIsTimeSeriesReport } from '../reportUtils/getReportCharacteristics';
export const DIMENSION_CATEGORIES = {
  NO_DIMENSIONS: 'NO_DIMENSIONS',
  BRAND: 'BRAND',
  TEAM: 'TEAM',
  USER: 'USER',
  CAMPAIGN: 'CAMPAIGN',
  SOURCE: 'SOURCE',
  DATE: 'DATE',
  SEARCH: 'SEARCH',
  ASSET: 'ASSET',
  STAGE: 'STAGE',
  PIPELINE: 'PIPELINE',
  ACTIVITY_TYPE: 'ACTIVITY_TYPE',
  SEQUENCE: 'SEQUENCE',
  ACTIVITY_OUTCOME: 'ACTIVITY_OUTCOME',
  ROLE: 'ROLE',
  INDUSTRY: 'INDUSTRY',
  // COMPANY: 'COMPANY',  - target accounts, COMPANIES data type & 'name' property; maybe could be indiv record dimension
  PRODUCT: 'PRODUCT',
  CHATFLOW: 'CHATFLOW',
  REASON: 'REASON'
};
const DIMENSION_CATEGORY_KEYWORDS = {
  [DIMENSION_CATEGORIES.TEAM]: ['team'],
  [DIMENSION_CATEGORIES.USER]: ['user', 'owner', 'created_by'],
  [DIMENSION_CATEGORIES.CAMPAIGN]: ['campaign'],
  // may need _id/name etc...same for sequence, product, chatflow
  [DIMENSION_CATEGORIES.SOURCE]: ['source', 'channel'],
  [DIMENSION_CATEGORIES.DATE]: ['date'],
  [DIMENSION_CATEGORIES.ASSET]: ['breakdown'],
  [DIMENSION_CATEGORIES.STAGE]: ['stage'],
  [DIMENSION_CATEGORIES.PIPELINE]: ['pipeline'],
  [DIMENSION_CATEGORIES.ACTIVITY_TYPE]: ['engagement_type'],
  [DIMENSION_CATEGORIES.SEQUENCE]: ['sequence'],
  [DIMENSION_CATEGORIES.ACTIVITY_OUTCOME]: ['outcome', 'call_disposition'],
  [DIMENSION_CATEGORIES.ROLE]: ['persona', 'role', 'customer_profile'],
  [DIMENSION_CATEGORIES.INDUSTRY]: ['industry'],
  [DIMENSION_CATEGORIES.PRODUCT]: ['product'],
  [DIMENSION_CATEGORIES.CHATFLOW]: ['chatflow'],
  [DIMENSION_CATEGORIES.REASON]: ['reason'],
  [DIMENSION_CATEGORIES.BRAND]: ['business_unit']
};
export const getDimensionCategoriesFromReport = report => {
  if (isJourneyReport(report)) {
    return [];
  }
  if (isConfigReport(report) && isSearchReport(report)) {
    return [DIMENSION_CATEGORIES.SEARCH];
  }
  const dimensions = getStandardFieldType(report, STANDARD_FIELD_TYPES.DIMENSIONS, []);
  if (dimensions.length === 0) {
    return [DIMENSION_CATEGORIES.NO_DIMENSIONS];
  }
  const {
    property: firstDimensionProperty
  } = dimensions[0];
  const categoryMatch = Object.keys(DIMENSION_CATEGORY_KEYWORDS).find(category => DIMENSION_CATEGORY_KEYWORDS[category].some(keyword => firstDimensionProperty.includes(keyword)));
  if (categoryMatch) {
    return [categoryMatch];
  }
  if (getIsTimeSeriesReport(report)) {
    return [DIMENSION_CATEGORIES.DATE];
  }
  return [];
};
export const getDimensionTypesFromReports = reports => {
  const dimensionTypes = reports.flatMap(report => getDimensionCategoriesFromReport(report)).toJS();
  const allDimensionTypesCount = dimensionTypes.length;
  const dimensionTypePercentages = dimensionTypes.reduce((memo, dimensionType) => {
    memo[dimensionType] = (memo[dimensionType] || 0) + 1 / allDimensionTypesCount;
    return memo;
  }, {});
  const majorityDimensionTypes = Object.keys(dimensionTypePercentages).filter(dimensionType => dimensionTypePercentages[dimensionType] > 0.5);
  return majorityDimensionTypes;
};